import { render, staticRenderFns } from "./vedioOrder.vue?vue&type=template&id=79d90e7a&"
import script from "./vedioOrder.vue?vue&type=script&lang=js&"
export * from "./vedioOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports